<div *transloco="let t">
	<div class="px-12 flex flex-row">
		<div class="pt-6 pb-3 title">
			{{ t('settings.devSettings.supportTools.imitateUser') }}
			<mat-icon [matTooltip]="t('settings.devSettings.supportTools.impersonationDescription')" [svgIcon]="icons.get('infoOutline')"></mat-icon>
		</div>
	</div>
	<div class=" px-12 flex flex-wrap flex-row {{ isMobile() ? 'w-full' : 'w-2/3' }}">
		<div class="{{ isMobile() ? 'w-full' : 'w-2/3' }}">
			<mat-form-field appearance="fill" class="p-2 w-full">
				<input [(ngModel)]="imitateMail" matInput name="imitate-mail-cy" placeholder="{{ t('settings.devSettings.supportTools.userName') }}" required />
				<mat-error>{{ t('settings.devSettings.supportTools.enterValidMail') }}</mat-error>
			</mat-form-field>
		</div>
	</div>
	<div class="px-12 flex flex-wrap flex-row">
		<div>
			<button
				(click)="imitateUser()"
				[disabled]="!imitateMail"
				[style]="isMobile() ? 'width:100%' : ''"
				appearance="fill"
				class="p-2 m-2"
				color="primary"
				mat-raised-button
				type="button">
				<mat-icon>supervisor_account</mat-icon>
				@if (!isMobile()) {
					<span>
						{{ t('commonActions.submit') }}
					</span>
				}
			</button>
		</div>
	</div>

	<div class="px-12 flex flex-row">
		<div class="flex flex-row items-start align-center pt-6 pb-3 title">
			{{ t('settings.devSettings.supportTools.clearKeycloakCache') }}
			<mat-icon [matTooltip]="t('settings.devSettings.supportTools.clearKeycloakCacheDescription')" [svgIcon]="icons.get('infoOutline')"></mat-icon>
		</div>
	</div>
	<div class="px-12 flex flex-wrap flex-row">
		<div>
			<button
				(click)="clearKeycloakCache()"
				[style]="isMobile() ? 'width:100%' : ''"
				appearance="fill"
				class="p-2 m-2"
				color="primary"
				mat-raised-button
				type="button">
				<mat-icon [svgIcon]="icons.get('delete')"></mat-icon>
				@if (!isMobile()) {
					<span>
						{{ t('settings.devSettings.supportTools.clearKeycloakCacheAction') }}
					</span>
				}
			</button>
		</div>
	</div>

	<div class="px-12 flex flex-row">
		<div class="pt-6 pb-3 title">
			{{ t('settings.devSettings.supportTools.updateUserMail') }}
		</div>
	</div>
	<div class=" px-12 flex flex-wrap flex-row {{ isMobile() ? 'w-full' : 'w-2/3' }}">
		<div class="{{ isMobile() ? 'w-full' : 'w-1/3' }}">
			<mat-form-field appearance="fill" class="w-full p-2">
				<input
					[formControl]="currentMailFC"
					matInput
					placeholder="{{ t('settings.devSettings.supportTools.currentMail') }}"
					required
					(keyup)="checkMailValidator()" />
				<mat-error>{{ errorMsg() }}</mat-error>
			</mat-form-field>
		</div>
		<div class="{{ isMobile() ? 'w-full' : 'w-1/3' }}">
			<mat-form-field appearance="fill" class="w-full p-2">
				<input
					[formControl]="newMailFC"
					matInput
					placeholder="{{ t('settings.devSettings.supportTools.newMail') }}"
					required
					(keyup)="checkMailValidator()" />
				<mat-error>{{ errorMsg() }}</mat-error>
			</mat-form-field>
		</div>
	</div>
	<div class="px-12 flex flex-wrap flex-row">
		<div>
			<button mat-raised-button color="primary" [disabled]="!allowUpdate()" (click)="confirmUpdateMail()">
				<mat-icon [svgIcon]="icons.get('save')"></mat-icon>
				{{ t('commonActions.save') }}
			</button>
		</div>
	</div>
	<div class="px-12 flex flex-row">
		<div class="pt-6 pb-3 title">
			{{ t('settings.devSettings.supportTools.deleteUser') }}
		</div>
	</div>
	<div class=" px-12 flex flex-wrap flex-row {{ isMobile() ? 'w-full' : 'w-2/3' }}">
		<div class="{{ isMobile() ? 'w-full' : 'w-2/3' }}">
			<mat-form-field appearance="fill" class="w-full p-2">
				<input
					[formControl]="deleteUserFC"
					matInput
					placeholder="{{ t('settings.devSettings.supportTools.mailAddress') }}"
					(keyup)="checkDeleteUserValidator()" />
				<mat-error>{{ deleteUserErrorMsg() }}</mat-error>
			</mat-form-field>
		</div>
	</div>
	<div class="px-12 flex flex-wrap flex-row">
		<div>
			<button mat-raised-button color="primary" (click)="confirmDeleteUser()" [disabled]="!allowDeleteUser()">
				<mat-icon [svgIcon]="icons.get('delete')"></mat-icon>
				{{ t('settings.devSettings.supportTools.deleteUser') }}
			</button>
		</div>
	</div>
</div>
